import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import formatDate from "../../util/dateFormat";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  DateConstants,
  modelName,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { getEncodedLastkey, getEncodedValue } from "../forms/utility";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { getVouchers } from "../../services/ApiServices/vouchers";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}

const EVoucherTransaction = () => {
  const { getUserPermission: eVoucherPermissions } = usePermissionGetter(
    permissionsConstants.voucher_transaction,
    permissionsConstants.voucher_transaction
  );
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const [listOfSourece, setListOfSourceVoucher] = useState<any>([]);
  const { merchantId } = selectedMerchatDetails;
  const [openFilter, setOpenFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  const [lastKey, setLastKey] = useState<any>(null);
  const [fromKey, setFromKey] = useState<Number>(0);
  const [totalDataCount, setTotalDataCount] = useState<Number>(0);
  const [isInitialApiCall, setIsInitialApiCall] = useState(true);

  const [filterState, setFilterState] = useState({
    utilizedDate: "",
    subcategory: "",
  });
  const [type, setType] = React.useState(filterConstants.All.toLowerCase());
  const buttonStyles = useButtonStyles();
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const columns: TableColumn[] = [
    { key: "loyaltyCardNumber", header: "Loyalty Card No." },
    { key: "voucherSerialNumber", header: "Voucher Serial Number" },
    { key: "voucherTitle", header: "Voucher Title" },
    { key: "transactionCode", header: "Transaction ID" },
    { key: "amount", header: "Amount" },
    { key: "voucherUtilisedDate", header: "Utilised Date/Time" },
    { key: "type", header: "Type" },
  ];

  const [filterStates, setFilterStates] = useState<any>([
    {
      fieldValue: "merchantId",
      value: `${merchantId}`,
      operator: operatorConstants.equal,
    },
  ]);
  const resetFilterState = () => {
    setFilterState({
      utilizedDate: "",
      subcategory: "",
    });
    setFilterStates([
      {
        fieldValue: "merchantId",
        value: `${merchantId}`,
        operator: operatorConstants.equal,
      },
    ]);
    onReset();
  };

  const onReset = () => {
    setFromKey(0);
    setTotalDataCount(0);
    setLastKey(null);
    setIsInitialApiCall(true);
    setFilterActive(false);
    setData([]);
  };

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const handleChangeSubcategory = (event: SelectChangeEvent) => {
    getAllFields(
      "purpose",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      subcategory: event.target.value,
    }));
  };

  const handleClose = () => {
    setOpenFilter(false);
  };
  // pagination
  const FetchVoucherTransaction = async (
    filters: string,
    canMergeData?: boolean
  ) => {
    try {
      let baseParams = `fromKey=${fromKey}`;
      baseParams += `&${filters}`;
      if (lastKey) {
        baseParams += `&${getEncodedLastkey(lastKey)}`;
      }
      const response = await getVouchers(baseParams); // await axios.get(currentURl);
      const {
        lastKey: nextPageKey,
        totalCount,
        result,
        fromKey: apiFromKey,
      } = response?.result?.data;
      if (nextPageKey) setLastKey(nextPageKey);
      else setLastKey(null);
      setFromKey(apiFromKey ? apiFromKey : 0);
      setTotalDataCount(totalCount);
      const newData = result;
      const mappedData = newData.map((voucherData: any) => {
        const voucher = voucherData?._source;
        return {
          memberName: voucher.memberName ? voucher.memberName : "-",
          loyaltyCardNumber: voucher.loyaltyNo ? voucher.loyaltyNo : "-",
          voucherTitle: voucher.title ? voucher.title : "-",
          voucherSerialNumber: voucher.couponCode ? voucher.couponCode : "-",
          transactionCode: voucher.transaction_id
            ? voucher.transaction_id
            : "-",
          amount:
            voucher.amount || voucher.amount === 0 ? `$${voucher.amount}` : "-",
          voucherRedeemedDate: voucher.updatedAt
            ? formatDate(voucher.updatedAt)
            : "-",
          voucherUtilisedDate: voucher.utilizedDate
            ? formatDate(voucher.utilizedDate)
            : "-",
          voucherExpiryDate: voucher.expiryDate
            ? formatDate(voucher.expiryDate)
            : "-",
          voucherStatus: voucher.status ? voucher.status : "-",
          sourceOfVoucher: voucher.campaign_type ? voucher.campaign_type : "-",
          type: voucher.purpose ? voucher.purpose : "-",
        };
      });
      const datatoSet = canMergeData ? [...data, ...mappedData] : mappedData;
      setData(datatoSet);
      if (!listOfSourece.length) {
        const uniqueSources = Array.from(
          new Set(datatoSet.map((voucher: any) => voucher.type))
        );
        setListOfSourceVoucher(uniqueSources);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
      setIsInitialApiCall(false);
    }
  };

  // new Search and filter
  const searchInputRef = useRef<HTMLInputElement>();

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    let url = getParamValue();
    FetchVoucherTransaction(url, canHaveExistingData);
  };

  const getParamValue = () => {
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    return url;
  };
  const handleApply = () => {
    onReset();
    setOpenFilter(false);
    const newStatus = filterStates.slice(1);
    newStatus && setFilterActive(true);
  };

  const handleSearch = () => {
    onReset();
  };
  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  const handleSendExport = async () => {
    const getFilterURL = getParamValue();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.utilizedVouchers,
      hashKey.campaignType,
      hashValue.event
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <ExportDialog
        closeDialog={setOpen}
        emailSent={emailSent}
        exportTitle="E-Voucher Transaction"
        handleClose={handleClose}
        open={open}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid
        height={"20%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={4}
        py={5}
        borderBottom={theme.border?.smallGrey}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Voucher Transactions
        </Typography>
        <Grid display={"flex"} gap={4}>
          <SearchInput
            HelpTip={SearchToolTip.MerchantVoucher}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          {eVoucherPermissions("read") && (
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          )}
          {eVoucherPermissions("export") && (
            <CommonButton
              variant="text"
              buttonTitle="Export"
              color="secondary"
              onClick={() => setOpen(true)}
              disabled={!data.length}
            />
          )}

          <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
            <Grid sx={{ width: "483px", py: 4, px: 2 }}>
              <DialogTitle
                display={"flex"}
                justifyContent={"space-between"}
                borderBottom={theme.border?.smallGrey}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    color: theme.color?.primary,
                    fontSize: theme.font?.fontSize.large,
                    fontWeight: theme.font?.fontWeight.thicker,
                  }}
                >
                  Filter
                </Typography>
                <IconButton onClick={() => setOpenFilter(false)}>
                  <CloseOutlinedIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent
                sx={{
                  borderBottom: theme.border?.smallGrey,
                  mt: 2,
                }}
              >
                <Grid mb={4}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Utilized Date
                  </Typography>
                  <Grid display={"flex"} mt={2} gap={2} width={"70%"}>
                    <TextField
                      value={filterState.utilizedDate}
                      type="date"
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        getAllFields(
                          "utilizedDate",
                          new Date(e.target.value).getTime(),
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          utilizedDate: e.target.value,
                        }));
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    ></TextField>
                  </Grid>
                </Grid>
                <Grid
                  mb={2}
                  borderTop={theme.border?.newGreyBorder}
                  pt={4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={2}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Type
                  </Typography>
                  <Grid width={"70%"}>
                    <Select
                      label=""
                      value={filterState.subcategory}
                      onChange={handleChangeSubcategory}
                      fullWidth
                      size="small"
                      defaultValue={filterConstants.All.toLowerCase()}
                    >
                      {listOfSourece.map((v: string) => (
                        <MenuItem value={v}>{v}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
                <Button
                  sx={{ ...buttonStyles.outlinedSecondary }}
                  onClick={resetFilterState}
                >
                  Reset
                </Button>
                <Button
                  sx={{ ...buttonStyles.containedSecondary }}
                  onClick={handleApply}
                >
                  Apply
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      </Grid>
      <Grid p={2}>
        {eVoucherPermissions("read") && (
          <InfiniteTable
            header={columns}
            contentItems={data}
            hasMoreRecords={lastKey !== null}
            fetchMoreData={() => {
              bindSearchAndFilter(true);
            }}
            isInitialLoading={isInitialApiCall}
            totalRecords={totalDataCount}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default EVoucherTransaction;

